import { MessageActionEnum } from '@shared/enums';

export const MessageActionMap: { [key in MessageActionEnum]: string } = {
  [MessageActionEnum.Save]: 'field.validation.success.save.message',
  [MessageActionEnum.Delete]: 'field.validation.success.delete.message',
  [MessageActionEnum.Upload]: 'field.validation.success.file.message',
  [MessageActionEnum.Sent]: 'field.validation.success.sent.message',
  [MessageActionEnum.Create]: 'field.validation.success.create.message'
};
